export default __webpack_public_path__ + "static/media/1.bb7cfe7b.mp4";